import * as React from "react";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import RotateRightIcon from "@material-ui/icons/RotateRight";

import Tooltip from "@material-ui/core/Tooltip";
import {Avatar} from "@material-ui/core";
import { MUIDataTableMeta } from "mui-datatables";
import * as Dati from "../../../Dati";
import { Trad } from "../../../components";
import {IsPolicyExpired, IsPolicyExpiring, GetURL, GetURLRinnovata} from "../../helpers/Policies";
import Grid from "@material-ui/core/Grid";


export const GetRenewalPoliciesListColumns = (
    tableData: Dati.CDatiPolizzaGenerale[] | undefined,
    OnClickRenew: (policy: Dati.CDatiPolizzaGenerale) => void,
    OnClickCreateNew: (policy: Dati.CDatiPolizzaGenerale) => void,
    OnClickTerminate: (policy: Dati.CDatiPolizzaGenerale) => void) => 
    [
        {
            name: "Polizza",
            label: `${Trad.Trad("Numero")}/${Trad.Trad("Contraente")}`,
            options: {
                filter: false,
                customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                    const rowData = { ...new Dati.CDatiPolizzaGenerale(), ...tableMeta.tableData[tableMeta.rowIndex] };
                    
                    return (
                        <>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <a href={GetURL(rowData)}>
                                        {rowData.Sinistro == null ? val : <span style={{color: "red"}}>{val}</span>}
                                    </a>
                                </Grid>
                                <Grid item xs={6}>
                                    {rowData.TacitoRinnovo ? <span style={{marginLeft: 10}}>TR</span> : ''}
                                </Grid>

                            </Grid>
                            {rowData.Contraente}<br/>
                            {rowData.ID_PolizzaRinnovata > 0 &&
                                <div>
                                    <a href={GetURLRinnovata(rowData)}>
                                        {<b style={{color: "orangered"}}>{rowData.PolizzaRinnovata}</b>}
                                    </a>
                                </div>
                            }
                        </>
                    );
                },
                setCellProps: (cellValue: string, rowIndex: number) => {
                    const isTacito = tableData && tableData[rowIndex].TacitoRinnovo;
    
                    return {
                        className: clsx({
                            tacito: tableData && isTacito
                        })
                    };
                }
            }
        },
        {
            name: "TipoRamo",
            label: `${Trad.Trad("Ramo")}/${Trad.Trad("Prodotto")}`,
            options: {
                filter: false,
                customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                    const rowData = { ...new Dati.CDatiPolizzaGenerale(), ...tableMeta.tableData[tableMeta.rowIndex] };
                    
                    return (
                        <>
                            {val}
                            <br />
                            {rowData.TipoProdotto}
                        </>
                    );
                }
            }
        },
        {
            name: "AnagPOS",
            label: Trad.Trad("POS"),
            options: {
                filter: false
            }
        },
        {
            name: "Sinistri",
            label: `${Trad.Trad("Sinistri")}`,
            options: {
                filter: false,
                customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                    const rowData = { ...new Dati.CDatiPolizzaGenerale(), ...tableMeta.tableData[tableMeta.rowIndex] };
    
                    return (
                        <>
                            {val} - {rowData.DataSinistro != undefined ? Trad.Trad(rowData.DataSinistro) : ''}
                            <br />
                            {rowData.SinistroNote}
                        </>
                    );
                }
            }
        },
        {
            name: "Appendici",
            label: `${Trad.Trad("Appendici")}`,
            options: {
                filter: false,
                customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                    const rowData = { ...new Dati.CDatiPolizzaGenerale(), ...tableMeta.tableData[tableMeta.rowIndex] };

                    return (
                        <>
                            {rowData.Appendici}
                        </>
                    );
                }
            }
        },
        {
            name: "DataEffetto",
            label: Trad.Trad("DataEffetto"),
            options: {
                filter: false,
                customBodyRender: (val: string) => Trad.Trad(val)
            }
        },
        {
            name: "DataFine",
            label: Trad.Trad("DataFine"),
            options: {
                filter: false,
                customBodyRender: (val: string) => <span>{Trad.Trad(val)}</span>,
                setCellProps: (cellValue: string, rowIndex: number) => {
                    const endDate = tableData && tableData[rowIndex].DataFine;
    
                    return {
                        className: clsx({
                            expired: endDate && IsPolicyExpired(endDate),
                            expiring: endDate && IsPolicyExpiring(endDate)
                        })
                    };
                }
            }
        },
        {
            name: "Edit",
            label: Trad.Trad("Operazioni"),
            
            options: {
                filter: false,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center"
                }),
                setCellProps: () => ({
                    align: "center",
                    style: { minWidth: "150px" }
                }),
                customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                    const rowData = { ...new Dati.CDatiPolizzaGenerale(), ...tableMeta.tableData[tableMeta.rowIndex] };
                    const data = tableData ? tableData[tableMeta.rowIndex] : new Dati.CDatiPolizzaGenerale();
                    
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                {data.TacitoRinnovo &&
                                    <Tooltip title={Trad.Trad("Rinnovo")}>
                                        <IconButton aria-label="Rinnovo" size="small" onClick={() => OnClickRenew(data)}>
                                            <RotateRightIcon />
                                        </IconButton>
                                    </Tooltip>
                                }
                            </Grid>
                            <Grid item xs={4}>
                                <Tooltip title={Trad.Trad("Nuovo preventivo")}>
                                    <IconButton aria-label="Nuovo preventivo" size="small" onClick={() => OnClickCreateNew(data)}>
                                        <CreateNewFolderIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4}>
                                <Tooltip title={Trad.Trad("Disdetta")}>
                                    <IconButton aria-label="Disdetta" size="small" onClick={() => OnClickTerminate(data)}>
                                        <RemoveCircleIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    );
                }
            }
        }
    ];



// WEBPACK FOOTER //
// ./src/inar2/components/RenewalPoliciesList/RenewalPoliciesListColumns.tsx